// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TerminalCompatibilityMatrix: MarkdocTagRegistration = {
  tag: 'terminal-compatibility-matrix',
  component: 'TerminalCompatibilityMatrix',
  attributes: {
    compatibilityData: {
      type: String,
      description: 'Terminal compatibility data from the terminal context',
      localizable: false,
    },
    onlyShowIntegrationCountry: {
      type: Boolean,
      required: false,
      default: false,
      description:
        'Whether to limit the table to only show the row for the country in the terminal-integration-country pref',
      localizable: false,
    },
    showCountryFilterToggle: {
      type: Boolean,
      required: false,
      default: false,
      description:
        'Whether to show a toggle below the table that temporarily switches to showing all countries, only applicable if onlyShowIntegrationCountry is provided',
      localizable: false,
    },
  },
};
